import { NgModule, APP_INITIALIZER } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ServicesModule } from "@nexu-library/utilities";
import { EnvironmentService } from "@nexu-library/utilities";
import { AuthGuard } from "projects/dealership/src/app/guards/auth.guard";

// Interceptors
import { PublicAuthInterceptor } from "./interceptors/public-auth.interceptor";
import { StripUndefinedParamsInterceptor } from "projects/dealer/src/app/strip-undefined-params.interceptor";
import { DsIconsModule } from "@nexu-library/ui-kit";

// Factory function for APP_INITIALIZER
export function initializeEnvironment(envService: EnvironmentService) {
  return (): Promise<void> => {
    if (environment.production) {
      // In production, load from envService (API)
      return envService.load();
    }

    // In development, use environment.ts values
    envService.setConfig(environment);
    return Promise.resolve();
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, BrowserAnimationsModule, AppRoutingModule, HttpClientModule, ServicesModule, DsIconsModule],
  providers: [
    AuthGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeEnvironment,
      deps: [EnvironmentService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: StripUndefinedParamsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PublicAuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
